import { applyOptAttr, readAttr } from "@/utils";
import { widgetConfigSchema, type WidgetConfig } from "@/config";
import { isDevOpenChatbotPreviewEnabled } from "@/core/devMockSession";

const OPTIONAL_ATTRS: Array<[keyof WidgetConfig, string]> = [
  ["goto", "data-goto"],
  ["gotoFail", "data-gotoFail"],
  ["provisioning", "data-provisioning"],
  ["qrCode", "data-qrCode"],
  ["altTheme", "data-altTheme"],
  ["codeChallenge", "data-codeChallenge"],
  ["codeChallengeMethod", "data-codeChallengeMethod"],
  ["state", "data-state"],
  ["triggerElementId", "data-triggerelementid"],
  ["language", "data-language"],
  // Logged-out avatar override temporarily disabled (see Dropdown + README):
  // ["avatarUrl", "data-avatarUrl"],
  // ["avatarWidth", "data-avatarWidth"],
  ["cacheBreakerMin", "data-cache-breaker-min"],
];

export const readConfigFromScript = (scriptId = "md-login"): WidgetConfig => {
  const el = document.getElementById(scriptId);
  if (!el) throw new Error("[telekomId] Missing #md-login script tag");

  const raw = {
    clientId: readAttr(el, "data-client_id") ?? "",
    redirectUri: readAttr(el, "data-redirect_uri") ?? "",
    logouturl: readAttr(el, "data-logouturl") ?? "",
    responseType: readAttr(el, "data-response_type") ?? "code",
    scope: (readAttr(el, "data-scope") ?? "email openid").replace(/\+/g, " "),
    chatbot: (readAttr(el, "data-chatbot") ?? "false") as any,
    goto: undefined,
    gotoFail: undefined,
    provisioning: undefined,
    qrCode: undefined,
    altTheme: undefined,
    codeChallenge: undefined,
    codeChallengeMethod: undefined,
    state: undefined,
    triggerElementId: undefined,
    language: undefined,
    cacheBreakerMin: undefined,
  } satisfies Partial<WidgetConfig> &
    Pick<
      WidgetConfig,
      | "clientId"
      | "redirectUri"
      | "logouturl"
      | "responseType"
      | "scope"
      | "chatbot"
    >;

  OPTIONAL_ATTRS.forEach(([k, attr]) => applyOptAttr(raw, k, el, attr));

  const parsed = widgetConfigSchema.parse(raw);

  if (import.meta.env.DEV && isDevOpenChatbotPreviewEnabled()) {
    return { ...parsed, chatbot: true };
  }

  return parsed;
};
